"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOBS_API_TIMEOUT_MS = exports.DEFAULT_API_TIMEOUT_MS = void 0;
exports.isAbortError = isAbortError;
exports.createApiClient = createApiClient;
const axios_1 = __importDefault(require("axios"));
/** Default Axios timeout for API client (ms). */
exports.DEFAULT_API_TIMEOUT_MS = 30000;
/** Longer timeout for job list/search calls (`GET` / `POST /jobs`). */
exports.JOBS_API_TIMEOUT_MS = 50000;
/** Check if error is an abort/cancel (should be rethrown without handling) */
function isAbortError(error) {
    if (axios_1.default.isCancel(error))
        return true;
    if (error instanceof Error) {
        if (error.name === 'AbortError' || error.name === 'CanceledError')
            return true;
        const err = error;
        if (axios_1.default.isAxiosError(error) && err.code === 'ERR_CANCELED')
            return true;
    }
    return false;
}
/**
 * Create a unified API client for REST calls.
 * Each app configures baseURL, headers, and error handling.
 */
function createApiClient(config) {
    var _a, _b;
    const api = axios_1.default.create({
        baseURL: config.baseURL,
        withCredentials: (_a = config.withCredentials) !== null && _a !== void 0 ? _a : true,
        timeout: (_b = config.timeout) !== null && _b !== void 0 ? _b : exports.DEFAULT_API_TIMEOUT_MS,
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (config.getRequestHeaders) {
        api.interceptors.request.use((axiosConfig) => {
            var _a;
            Object.assign((_a = axiosConfig.headers) !== null && _a !== void 0 ? _a : {}, config.getRequestHeaders());
            return axiosConfig;
        }, (error) => Promise.reject(error));
    }
    const { handleError } = config;
    const get = async (url, axiosConfig, options) => {
        var _a;
        try {
            const response = await api.get(url, {
                ...axiosConfig,
                ...((options === null || options === void 0 ? void 0 : options.timeout) !== undefined ? { timeout: options.timeout } : {}),
            });
            return response.data;
        }
        catch (error) {
            handleError(error, (_a = options === null || options === void 0 ? void 0 : options.showErrorToast) !== null && _a !== void 0 ? _a : true);
            throw new Error('Unreachable');
        }
    };
    const post = async (url, data, options) => {
        var _a;
        try {
            const response = await api.post(url, data, {
                ...((options === null || options === void 0 ? void 0 : options.timeout) !== undefined ? { timeout: options.timeout } : {}),
                ...((options === null || options === void 0 ? void 0 : options.headers) !== undefined ? { headers: options.headers } : {}),
            });
            return response.data;
        }
        catch (error) {
            handleError(error, (_a = options === null || options === void 0 ? void 0 : options.showErrorToast) !== null && _a !== void 0 ? _a : true);
            throw new Error('Unreachable');
        }
    };
    const patch = async (url, data, options) => {
        var _a;
        try {
            const response = await api.patch(url, data, {
                ...((options === null || options === void 0 ? void 0 : options.timeout) !== undefined ? { timeout: options.timeout } : {}),
            });
            return response.data;
        }
        catch (error) {
            handleError(error, (_a = options === null || options === void 0 ? void 0 : options.showErrorToast) !== null && _a !== void 0 ? _a : true);
            throw new Error('Unreachable');
        }
    };
    const del = async (url, options) => {
        var _a;
        try {
            const response = await api.delete(url, {
                ...((options === null || options === void 0 ? void 0 : options.timeout) !== undefined ? { timeout: options.timeout } : {}),
            });
            return response.data;
        }
        catch (error) {
            handleError(error, (_a = options === null || options === void 0 ? void 0 : options.showErrorToast) !== null && _a !== void 0 ? _a : true);
            throw new Error('Unreachable');
        }
    };
    return { get, post, patch, delete: del };
}
